'use strict'

import { Token } from './tokens';

export enum NetworkType {
  EVM = 'evm',
  SOLANA = 'solana',
}

export type Rpc = {
  id: string;
  name: string;
  url: string;
};

export type Network = {
  id: string;
  name: string;
  iconUrl: string;
  networkType?: NetworkType;
  factoryContractAddress?: `0x${string}`;
  chainId?: string;
  xbrStakingPoolContractAddress?: `0x${string}`;
  multicallContractAddress?: `0x${string}`;
  programId?: string;
  rpcUrls: Rpc[];
  depositTokens: Token[];
};

export const isSolanaNetwork = (network?: Network | null): boolean =>
  (() => {
    const normalizedNetworkType = String(network?.networkType ?? '').toLowerCase();
    return (
      normalizedNetworkType === NetworkType.SOLANA ||
      Boolean(network?.programId && !network?.chainId)
    );
  })();
